// extracted by mini-css-extract-plugin
export default {"printTextArea":"TextElement__printTextArea___1Px8T"};